import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token: null,
};

const jwtTokenSlice = createSlice({
  name: 'jwtToken',
  initialState,
  reducers: {
    setJWT: (state, action) => {
      state.token = action.payload.token;
    },
    removeJWT: (state) => {
      state.token = null;
    },
  },
});

export const { setJWT, removeJWT } = jwtTokenSlice.actions;

export default jwtTokenSlice.reducer;
